// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__FwDI8","modal":"Modal_modal__9MGLr","slide-down":"Modal_slide-down__bkONw"};